<template>
  <!-- Note: for 2-way binding to work with store state the easiest way
       is to go through the parent object in the binding -->
  <select class="user-select" v-model="model[prop]">
    <option v-if="addAllOption" value="">any user</option>
    <option v-for="user in users">{{user}}</option>
  </select> 
</template>

<script>
export default {

  props: ['model', 'prop', 'addAllOption'],

  computed: {
    users () {
      return this.$store.state.users
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// user-select.vue?35dc19b7